import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Spinner from '../../util/Spinner';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, StandardBox } from '../../styles/styles';
import InviteForm from '../InviteForm';
import { safeEval } from '../../util/UtilFunctions';

const InviteInfo = () => {
  const { state } = useLocation();
  const { authStore, orgStore, dataStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [invite, setInvite] = useState(null);
  const { inviteID } = useParams();
  const contacts = dataStore.contactArray;

  useEffect(() => {
    const passedInvite = state ? state.invite : null;

    const fetchInvite = async () => {
      try {
        const { data } = await authStore.request.get(
          `${process.env.REACT_APP_API}/api/invitation/${inviteID}`,
        );
        setInvite(data);
      } catch (e) {
        console.error(e);
      }
    };

    const initialize = async () => {
      const requests = [];
      if (contacts.length === 0) {
        requests.push(dataStore.retrieveContacts());
      }
      if (passedInvite) {
        setInvite(passedInvite);
      } else {
        requests.push(fetchInvite());
      }
      await Promise.all(requests);
      setLoading(false);
    };
    initialize();
  }, []);
  if (isLoading) return <Spinner />;
  const { Email, Roles, InvitationId, ContactId } = invite;
  const modifyInvite = async values => {
    const { email, roles, contactId } = values;
    const { name: inviterName, email: inviterEmail } = authStore;
    const { settings } = orgStore;

    const contactName = safeEval(
      () => dataStore.getContactFromId(contactId).Name,
      null,
    );
    try {
      await authStore.request.post(
        `${process.env.REACT_APP_API}/api/invitation`,
        {
          email,
          roles,
          contactId,
          orgName: settings.Name,
          emailTemplateData: {
            inviter_name: inviterName,
            inviter_email: inviterEmail,
          },
          ...(contactName ? { name: contactName } : {}),
        },
      );
    } catch (e) {
      console.error(e);
    }
  };
  const formattedRoles = Roles.map(role => role.OrgRoleId);
  return (
    <FlexDiv>
      <StandardBox>
        <InviteForm
          initialValues={{
            email: Email,
            roles: formattedRoles,
            contactId: ContactId,
          }}
          handleSubmission={modifyInvite}
          inviteId={InvitationId}
        />
      </StandardBox>
    </FlexDiv>
  );
};

export default InviteInfo;
